export const houstonId = () => {
  // Route looks like http://localhost:3002/13_333a-0
  // So mayday_id is pathname minus /
  return window.location.pathname.slice(1);
}

const serverId = () => {
  return parseInt(houstonId().split('-').pop());
}

const findEnvironment = () => {
  switch (serverId()) {
    case 0:
      return 'staging.powerpanne.com'
    case 1:
      return 'app.benard-powerpanne.fr';
    case 2:
      return 'app.reda-powerpanne.fr'
    case 3:
      return 'app.pn-powerpanne.fr'
    case 4:
      return 'app.2000-powerpanne.fr'
    case 5:
      return 'app.3j-powerpanne.fr'
    case 6:
      return 'app.powerpanne.com'
    default:
      break;
  }
}

const CUSTOM_CABLE_DOMAIN_KEY = 'mayday:custom_cable_domain'

const isProductionEnvironment = () => {
  return document.querySelector('meta[name="rails-env"]')?.content === 'production'
}

// Lets a developer override the websocket domain on their own browser via
// the /url debug page. Read defensively: the override must stay inert in
// production even if the key was somehow set (e.g. via devtools).
const readCustomCableDomain = () => {
  if (isProductionEnvironment()) {
    return null
  }

  try {
    return localStorage.getItem(CUSTOM_CABLE_DOMAIN_KEY) || null
  } catch {
    return null
  }
}

export const cableUrl = () => {
  const domain = String(readCustomCableDomain() || (
    window.location.hostname === 'localhost' ? 'localhost:3000' : findEnvironment()
  ))
  const scheme = domain.startsWith('localhost') ? 'ws' : 'wss'
  return `${scheme}://${domain}/cable`
}
